export const FilterDateSectionTypes = {
    appointment: "appointment",
    completedOn: "completedOn",
    created: "created",
};
